export const CAREER_PROSPECTS_3_CONSTANTS = {
  CAREER_PROSPECTS_FIELDS_CONFIG: [
    {
      fieldName: "certificate_image",
      label: "Left column image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Logo grid / collage (PNG / JPG / WebP)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "certificate_image_alt",
      label: "Image alt text",
      value: "Tools and frameworks",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Tools and frameworks",
    },
    {
      fieldName: "title",
      label: "Headline — first line",
      value: "Probable",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "First line (e.g. Probable)",
      required: false,
      defaultValue: "Probable",
      rows: 2,
    },
    {
      fieldName: "title_text_color",
      label: "First line color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Headline — following lines",
      value: "Tools &\nFrameworks",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Use line breaks for multiple lines",
      required: false,
      defaultValue: "Tools &\nFrameworks",
      rows: 4,
    },
    {
      fieldName: "sub_title_text_color",
      label: "Following lines color",
      value: "#D35400",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#D35400",
      required: false,
      defaultValue: "#D35400",
    },
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable / disable section",
      defaultValue: true,
    },
  ],
};
